import QueryString from 'query-string';

interface UrlParams {
	projectId: string;
	env: string;
	exportJson:string;
	viewMode: string;
	roomId: string;
	menu: string;
	id: string;
	tab: string;
}

export default class UrlParamsService {
	static urlParams: UrlParams = {
		projectId: '',
		env: '',
		exportJson:'',
		viewMode: '',
		roomId: '',
		menu: '',
		id: '',
		tab: ''
	};

	static parseUrlParams() {
		const parsedUrl = QueryString.parse(location.search);

		if (typeof parsedUrl.projectId === 'string') {
			this.urlParams.projectId = parsedUrl.projectId;
		}
		if (typeof parsedUrl.env === 'string') {
			this.urlParams.env = parsedUrl.env;
		}
		if (typeof parsedUrl.exportJson === 'string') {
			this.urlParams.exportJson = parsedUrl.exportJson;
		}
		if (typeof parsedUrl.viewMode === 'string') {
			this.urlParams.viewMode = parsedUrl.viewMode;
		}
		if (typeof parsedUrl.roomId === 'string') {
			this.urlParams.roomId = parsedUrl.roomId;
		}
		if (typeof parsedUrl.menu === 'string') {
			this.urlParams.menu = parsedUrl.menu;
		}
		if (typeof parsedUrl.id === 'string') {
			this.urlParams.id = parsedUrl.id;
		}
		if (typeof parsedUrl.tab === 'string') {
			this.urlParams.tab = parsedUrl.tab;
		}
	}

	static updateUrlParam(param:string, value:string) {
		if(!param) {
			return;
		}

		if ('URLSearchParams' in window) {
            var searchParams = new URLSearchParams(window.location.search);
			if(value) {
				searchParams.set(param, value);
			}
			else {
				searchParams.delete(param);
			}
            
            var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
        }
	}
}
